import React from 'react'
import styled from 'styled-components'

import PropTypes from 'prop-types'

import Col from './col'
import footerLogo from "../images/logo-one-global.svg"
import facebookIcon from "../images/facebook.png"
import instagramIcon from "../images/instagram.png"
import linkedinIcon from "../images/linkedin.png"
import wechatIcon from "../images/wechat.png"
import weiboIcon from "../images/weibo.png"
import youtubeIcon from "../images/youtube.png"



const socialIcons = {
  facebook: facebookIcon,
  instagram: instagramIcon,
  linkedin: linkedinIcon,
  wechat: wechatIcon,
  weibo: weiboIcon,
  youtube: youtubeIcon,
}

const hasSocialIcon = name => name in socialIcons



const Footer = ({ address, logoLinkUrl, openHours, extraText, socialLinks, teams }) => {
  return (
    <FooterWrapper>
      <Col full>
        <h2><a href={logoLinkUrl}><img src={footerLogo} alt="OneSpace" /></a></h2>
      </Col>

      <Col>
        <h4>展销中心</h4>
        <p>{openHours}</p>
        <p>{address}</p>
        {extraText && (<p>{extraText}</p>)}
        <p>&nbsp;</p>
        <p><a href="/files/crown_privacy_policy.pdf" download target="_blank">Privacy Policy</a></p>

      </Col>

      {teams.map(({ detail, email, name, phone }) => (
        <Col minWidth="200px" key={name}>
          <h4>{name}</h4>
          <p><a href={`tel:${phone}`}>{phone}</a></p>
          <br />
          <p>{detail}</p>
          <p><a href={`mailto:${email}`}>{email}</a></p>
        </Col>
      ))}

      <Col>
        <h4>关注我们</h4>
        {Object.entries(socialLinks)
          .filter(([name]) => hasSocialIcon(name))
          .map(([name, url]) => (
            <a key={name} className="social-link" href={url} rel="noopener noreferrer" target="_blank">
              <img src={socialIcons[name]} alt={name} />
            </a>
          )
        )}
      </Col>

    </FooterWrapper>
  )
}

const FooterWrapper = styled.footer`
  max-width: 1600px;
  margin: 0 auto;
  padding: 4rem 3rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  align-items: flex-start;
  flex-wrap: wrap;

  .col {
    margin-bottom: 2em;
  }

  .col + .col {
    margin-right: 2em;
  }

  .social-link {
    cursor: pointer;
    display: inline-block;
    margin: 0 0.7em 0 0;
    vertical-align: middle;
  }

  h2 {
    font-size: inherit;
    padding: 0;

    img {
      width: 180px;
    }
  }

  h4 {
    margin-bottom: 0.4rem;
    padding-bottom: 0;
  }

  img {
    max-height: 1.75em;
    max-width: 16em;
    height: auto;
    width: auto;
  }

  p + p {
    margin-top: 0;
  }
`



Footer.propTypes = {
  address: PropTypes.string.isRequired,
  logoLinkUrl: PropTypes.string.isRequired,
  openHours: PropTypes.string.isRequired,
  extraText: PropTypes.string,
  socialLinks: PropTypes.object.isRequired,
  teams: PropTypes.arrayOf(
    PropTypes.shape({
      detail: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      phone: PropTypes.string.isRequired,
    })
  ).isRequired
}

export default Footer
